export const MIN_GT_FOR_MAPE = 5;
export const ERROR_DARK_GREEN_THRESHOLD = 5; // <=5%  => dark green
export const ERROR_LIGHT_GREEN_THRESHOLD = 10; // >=10% => light green
const FALLBACK_RATE = 0.5; // ±50% when n < MIN_GT_FOR_MAPE

/** Predicted MAPE in percent units, or null when n < MIN_GT_FOR_MAPE. */
export function predictedMape(n: number): number | null {
  if (n < MIN_GT_FOR_MAPE) return null;
  return 23.69 / Math.sqrt(n) - 0.54;
}

/** Fraction (0..1) used to build the ± expected range. */
export function uncertaintyRate(n: number): number {
  const mape = predictedMape(n);
  return mape === null ? FALLBACK_RATE : mape / 100;
}

/** Minimum ground truth count for which predictedMape(n) <= targetErrorPercent. */
export function samplesNeededForTargetError(
  targetErrorPercent: number,
): number {
  const n = Math.ceil((23.69 / (targetErrorPercent + 0.54)) ** 2);
  return Math.max(MIN_GT_FOR_MAPE, n);
}

/** Colour on a dark-green → light-green ramp for an uncertainty percentage. */
export function uncertaintyColor(uncertaintyPercent: number): string {
  const clamped = Math.min(
    Math.max(uncertaintyPercent, ERROR_DARK_GREEN_THRESHOLD),
    ERROR_LIGHT_GREEN_THRESHOLD,
  );
  const t =
    (clamped - ERROR_DARK_GREEN_THRESHOLD) /
    (ERROR_LIGHT_GREEN_THRESHOLD - ERROR_DARK_GREEN_THRESHOLD);
  const saturation = Math.round(80 - 40 * t); // 80% (vivid) → 40% (pale)
  const lightness = Math.round(25 + 45 * t); // 25% (dark) → 70% (pale)
  return `hsl(120, ${saturation}%, ${lightness}%)`;
}
